import React, { useEffect } from 'react';
import Carousel from 'react-elastic-carousel';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import SectionTitle from 'components/common/SectionTitle/SectionTitle';
import LibraryItem from 'components/common/LibraryItem';
import SkeletonCard from 'components/Library/LibraryList/SkeletonCard/SkeletonCard';
import { correctUploadPath } from 'core/utils/image-path-correction';
import { UseGetLibrary } from 'core/services/api/get-library';

import './Library.scss';
import { RouteEnum } from 'core/enum/route.enum';

const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 630, itemsToShow: 2 },
  { width: 945, itemsToShow: 3 },
  { width: 1260, itemsToShow: 4 },
  { width: 1575, itemsToShow: 5 },
];

const Library = () => {
  const {
    data,
    isError,
    isLoading,
    mutate,
  } = UseGetLibrary();

  useEffect(() => {
    mutate({
      page: 1,
      pageSize: 10,
    });
  }, []);

  if (isError) return null;

  const books = data?.data?.result?.item || [];

  if (isLoading) {
    return (
      <Container fluid className="pr-lg-5 pt-lg-5">
        <section>
          <div className="library-slider-container">
            <div className="d-flex justify-content-between align-items-center">
              <Link to={RouteEnum.Library} className="more-library-btn">
                مشاهده همه 
              </Link>
              <SectionTitle TitleText="کتابخانه" className="library-section-title" />
            </div>
            <Carousel itemPosition="CENTER" isRTL breakPoints={breakPoints}>
              {Array.from({ length: 5 }).map((_, idx) => (
                <SkeletonCard key={idx} />
              ))}
            </Carousel>
          </div>
        </section>
      </Container>
    );
  }

  return (
    <Container fluid className="pr-lg-5 pt-lg-5">
      <section >
        <div className="library-slider-container">
          <div className=" d-flex justify-content-between align-items-center">
            <Link to={RouteEnum.Library} className="more-library-btn">
              مشاهده همه 
            </Link>
            <SectionTitle TitleText="کتابخانه" className="library-section-title" />
          </div>

          <Carousel itemPosition="CENTER" isRTL breakPoints={breakPoints}>
            {books.length > 0 ? (
              books.map((book) => (
                <LibraryItem
                  key={book.id}
                  id={book.id}
                  image={correctUploadPath(book.imageThumbnail)}
                  title={book.title}
                  description={book.description}
                  bookData={book}
                />
              ))
            ) : (
              <h2
                style={{
                  color: 'red',
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                هیچ کتابی یافت نشد
              </h2>
            )}
          </Carousel>
        </div>
      </section>
    </Container>
  );
};

export default Library;